import { useEffect, useState } from "react";
import api from "@/lib/api";

const fmt = (v) => v ? new Date(v).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" }) : "—";

export function FulfilmentEvents({ orderId, tick }) {
  const [ev, setEv] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { if (open) api.get(`/quote-fulfilment/orders/${orderId}/events`).then((r) => setEv(r.data.events)).catch(() => setEv([])); }, [orderId, open, tick]);
  return (
    <div className="mt-2 rounded-lg border border-slate-200 bg-white" data-testid="fd-events">
      <button onClick={() => setOpen((o) => !o)} className="flex w-full items-center px-3 py-1.5 text-left text-[11px] font-bold uppercase tracking-wider text-slate-600" data-testid="fd-events-toggle">Fulfilment timeline<span className="ml-auto font-normal normal-case tracking-normal text-slate-500">{open ? "Hide" : "Show"}</span></button>
      {open && <ol className="max-h-72 space-y-1 overflow-auto px-3 pb-2 text-[11px]" data-testid="fd-events-list">
        {ev === null && <li className="text-slate-500">Loading…</li>}
        {ev?.length === 0 && <li className="text-slate-500">No events yet.</li>}
        {(ev || []).map((e, i) => (
          <li key={i} className="flex flex-wrap gap-x-2 border-l-2 border-sky-300 pl-2" data-testid={`fd-event-${i}`}>
            <span className="w-40 shrink-0 font-mono text-slate-500">{e.time_known === false ? "time not recorded" : fmt(e.at)}</span>
            <span className="font-semibold text-slate-900">{e.label}</span>
            <span className="text-slate-600">{e.recipient}{e.shipment_code ? ` · ${e.shipment_code}` : ""}{e.note ? ` · ${e.note}` : ""}</span>
            {e.historical && <span className="rounded bg-amber-50 px-1 text-[10px] font-bold text-amber-800">BACKFILLED</span>}
          </li>))}
      </ol>}
    </div>
  );
}
